import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useToast } from '../../ui/feedback';
import { AboutThisPage, PageHeader } from '../../ui/primitives';
import ReportPreview, { REPORTS, type ReportKey } from './ReportPreview';

export default function ReportsPage() {
  const toast = useToast();
  const [active, setActive] = useState<ReportKey | null>('concentration');
  return (
    <>
      <PageHeader
        title="Reports"
        subtitle="Standard registry reports, run on demand or scheduled, exported to Excel or PDF."
      />
      <AboutThisPage>
        <p>
          Every report reads the same ledger, so figures agree across the register, statements and
          ATO lodgements. Scheduled reports can be emailed to the trustee, auditor or fund
          administrator.
        </p>
      </AboutThisPage>
      <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', lg: '320px 1fr' } }}>
        <Stack spacing={1}>
          {REPORTS.map((report) => (
            <Paper
              key={report.key}
              variant="outlined"
              onClick={() => setActive(report.key)}
              onKeyDown={(event) => event.key === 'Enter' && setActive(report.key)}
              tabIndex={0}
              role="button"
              sx={{
                p: 1.75,
                cursor: 'pointer',
                borderColor: active === report.key ? 'primary.main' : undefined,
                bgcolor: active === report.key ? '#EEF2FF' : undefined,
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {report.name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {report.description}
              </Typography>
            </Paper>
          ))}
        </Stack>
        <Paper variant="outlined" sx={{ p: 2.5, minWidth: 0 }}>
          {active ? (
            <>
              <Stack
                useFlexGap
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ mb: 2, flexWrap: 'wrap', rowGap: 1 }}
              >
                <Typography variant="h6">
                  {REPORTS.find((report) => report.key === active)?.name}
                </Typography>
                <Stack direction="row" spacing={1}>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => toast('Report scheduled monthly to the trustee (demo)', 'info')}
                  >
                    Schedule
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => toast('Exported to Excel (demo)', 'info')}
                  >
                    Excel
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => toast('Exported to PDF (demo)', 'info')}
                  >
                    PDF
                  </Button>
                </Stack>
              </Stack>
              <ReportPreview reportKey={active} />
            </>
          ) : (
            <Typography color="text.secondary">Choose a report.</Typography>
          )}
        </Paper>
      </Box>
    </>
  );
}
